import zod from 'zod';
import { AddressFormSchema } from '../../AddressService/schemas';
import { MANDATORY_FIELD } from '../../../config/zodConfig';

export const SportUnityFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod
    .string({ message: MANDATORY_FIELD })
    .nonempty({ message: MANDATORY_FIELD }),
  address: AddressFormSchema,
});
